/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetCategoryBaseRequest } from '../../models/get-category-base-request';
import { GetCategoryResponse } from '../../models/get-category-response';

export interface PostApiCategoryV1$Plain$Params {

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
      body?: GetCategoryBaseRequest
}

export function postApiCategoryV1$Plain(http: HttpClient, rootUrl: string, params?: PostApiCategoryV1$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetCategoryResponse>> {
  const rb = new RequestBuilder(rootUrl, postApiCategoryV1$Plain.PATH, 'post');
  if (params) {
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetCategoryResponse>;
    })
  );
}

postApiCategoryV1$Plain.PATH = '/private/v1/categories';
